(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class StickyBuyButtons {
    constructor(element) {
      this.element = element;
      this.buttonsContainer = element.querySelector('.product-form-buttons');
      this.isMobile = window.matchMedia('(max-width: 749px)');
      this.isSticky = element.dataset.mobileSticky === 'true';

      if (this.isSticky && this.buttonsContainer) {
        this.init();
      }
    }

    init() {
      this.handleResize();

      // Listen for resize events
      this.isMobile.addEventListener('change', this.handleResize.bind(this));

      // Apply sticky behavior immediately if on mobile
      if (this.isMobile.matches) {
        this.makeSticky();
      }
    }

    makeSticky() {
      // Add padding to body to prevent layout shift
      const buttonHeight = this.buttonsContainer.offsetHeight || 80; // fallback height
      document.body.style.paddingBottom = `${buttonHeight + 16}px`; // Add some extra space
    }

    removeSticky() {
      // Remove padding from body
      document.body.style.paddingBottom = '';
    }

    handleResize() {
      if (this.isMobile.matches) {
        // Mobile view - apply sticky behavior
        this.makeSticky();
      } else {
        // Desktop view - remove padding
        this.removeSticky();
      }
    }

    destroy() {
      this.isMobile.removeEventListener('change', this.handleResize.bind(this));
      this.removeSticky();
    }
  }

  // Initialize sticky buy buttons
  document.addEventListener('DOMContentLoaded', () => {
    const stickyBuyButtons = document.querySelectorAll('.buy-buttons-block--mobile-sticky');
    stickyBuyButtons.forEach(element => new StickyBuyButtons(element));
  });

  // Handle page transitions (if using Shopify's theme editor or AJAX navigation)
  document.addEventListener('shopify:section:load', (event) => {
    const stickyBuyButtons = event.target.querySelectorAll('.buy-buttons-block--mobile-sticky');
    stickyBuyButtons.forEach(element => new StickyBuyButtons(element));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const productRecommendations = document.querySelector('.product-recommendations');

    if (!productRecommendations || !productRecommendations.classList.contains('product-recommendations--with-shapes')) {
      return;
    }

    const shapes = productRecommendations.querySelectorAll('.hover-shape');
    const productItems = productRecommendations.querySelectorAll('.resource-list__item--with-hover');

    if (shapes.length === 0 || productItems.length === 0) {
      return;
    }

    // Preload product images for better performance
    const preloadedImages = new Map();

    function preloadImage(src) {
      if (preloadedImages.has(src)) {
        return preloadedImages.get(src);
      }

      const img = new Image();
      img.src = src;
      preloadedImages.set(src, img);
      return img;
    }

    // Get product image from product card
    function getProductImage(productItem) {
      const img = productItem.querySelector('img');
      return img ? img.src : null;
    }

    // Update shape with product image
    function updateShapeImage(shape, imageSrc) {
      const imageContainer = shape.querySelector('.hover-shape__image');
      const existingImg = imageContainer.querySelector('.hover-shape__img');

      if (existingImg) {
        existingImg.src = imageSrc;
      } else {
        const img = document.createElement('img');
        img.className = 'hover-shape__img';
        img.src = imageSrc;
        img.alt = '';
        img.loading = 'lazy';
        imageContainer.appendChild(img);
      }
    }

    // Randomly assign images to shapes
    function populateShapes(excludeIndex = -1) {
      const availableImages = [];

      productItems.forEach((item, index) => {
        if (index !== excludeIndex) {
          const imageSrc = getProductImage(item);
          if (imageSrc) {
            availableImages.push(imageSrc);
          }
        }
      });

      if (availableImages.length === 0) return;

      shapes.forEach((shape, index) => {
        const randomImage = availableImages[Math.floor(Math.random() * availableImages.length)];
        preloadImage(randomImage);
        updateShapeImage(shape, randomImage);
      });
    }

    // Handle hover interactions
    let hoverTimeout;

    productItems.forEach((item, index) => {
      item.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        populateShapes(index);
      });

      item.addEventListener('mouseleave', function() {
        hoverTimeout = setTimeout(() => {
          // Optional: Clear images or keep them for next hover
        }, 300);
      });
    });

    // Initial population
    populateShapes();

    // Handle reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      shapes.forEach(shape => {
        const animateElements = shape.querySelectorAll('animate');
        animateElements.forEach(animate => {
          animate.remove();
        });
      });
    }

    // Performance optimization: Pause animations when not visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const animateElements = entry.target.querySelectorAll('animate');
        if (entry.isIntersecting) {
          animateElements.forEach(animate => {
            animate.beginElement();
          });
        } else {
          animateElements.forEach(animate => {
            animate.endElement();
          });
        }
      });
    }, { threshold: 0.1 });

    shapes.forEach(shape => {
      observer.observe(shape);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
